export default __webpack_public_path__ + "static/media/trumpet.c61bdda5.mp3";